<template>
  <div class="block">
    <!-- top search bar -->
    <div class="pa-5 d-flex">
      <div class="form-input-group flex-grow-1 mr-5">
        <div class="prepend-icon"><v-icon>search</v-icon></div>
        <input
          type="text"
          class="pl-42px"
          placeholder="搜尋"
          v-model="filter.keyword"
        />
      </div>
      <button class="btn btn-primary w-88px" @click="getShareholderDividendHistories">搜尋</button>
    </div>

    <!-- table -->
    <div class="table">
      <div class="table-head">
        <!-- column head -->
        <div class="form-item d-flex px-5 h-60px align-center">
          <h5 class="col-year">所屬年度</h5>
          <h5 class="col-money">股利</h5>
          <h5 class="col-date">除息交易日期</h5>
          <h5 class="col-money">盈餘配股</h5>
          <h5 class="col-date">除權交易日期</h5>
          <h5 class="col-date">公積配股</h5>
          <h5 class="col-date">股東會日期</h5>
          <h5 class="col-edit ml-auto">編輯</h5>
          <h5 class="col-delete">刪除</h5>
        </div>
      </div>
      <div class="table-body">
        <div
          class="form-item d-flex h-60px align-center"
          v-for="item in shareholderDividendHistories"
          :key="item.id"
        >
          <div class="h5 col-year">{{ item.year }}</div>
          <div class="h5 col-money">{{ item.cash }}</div>
          <div class="h5 col-date">
            {{ objectToDate(item.ex_dividend_date) }}
          </div>
          <div class="h5 col-money">
            {{ item.sre }}
          </div>
          <div class="h5 col-date">
            {{ objectToDate(item.ex_right_date) }}
          </div>
          <div class="h5 col-money">
            {{ item.scap }}
          </div>
          <div class="h5 col-date">
            {{ objectToDate(item.meeting_date) }}
          </div>

          <div class="h5 col-edit ml-auto">
            <button class="btn square" @click="editItem(item.id)">
              <v-icon>edit</v-icon>
            </button>
          </div>
          <div class="h5 col-delete">
            <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
          </div>
        </div>
      </div>
    </div>

    <!-- table footer -->
    <Pagination @handleNextPreEvent="getShareholderDividendHistories"
                model="shareholderDividendHistory">
    </Pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  components: {
    deleteDialog,
    Pagination,
  },
  computed: {
    ...mapState('shareholderDividendHistory', ['shareholderDividendHistories', 'filter']),
  },
  methods: {
    ...mapActions('shareholderDividendHistory', {
      getShareholderDividendHistories: 'find',
      destroyShareholderDividendHistory: 'destroy',
      clear: 'clear',
    }),
    editItem(id) {
      this.$router.push({
        name: 'DividendHistoryEdit',
        params: { id },
      });
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyShareholderDividendHistory(id).then(() => {
        this.getShareholderDividendHistories();
      });
    },
    stampToDate(stamp) {
      const dateObj = new Date(stamp);
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const date = String(dateObj.getDate()).padStart(2, '0');

      return `${year}年${month}月${date}日`;
    },
    objectToDate(stamp) {
      if (!stamp) return '無';
      const dateObj = new Date(stamp);
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1;
      const date = dateObj.getDate();
      return `${year}.${month}.${date}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-year {
    width: 56px;
    margin-right: 40px;
  }
  .col-date {
    width: 84px;
    margin-right: 40px;
    text-align: right;
  }
  .col-money {
    width: 84px;
    margin-right: 40px;
    text-align: right;
  }
  .col-event-name {
    width: 180px;
    margin-right: 10px;
  }
  .col-time {
    width: 100px;
    margin-right: 40px;
  }
}
</style>
